import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    HttpUrlGenerator,
    QueryParams
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { PremiumPay } from './premium-pay.model';

export const entityName = 'PremiumPay';

@Injectable()
export class PremiumPayDataService extends EfaactDataService<PremiumPay> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        log.verbose({
            type: `${entityName}DataService`,
            msg: '::'
        });
    }
    /***
     * PremiumPay always uses POST
     */
    getWithQuery(params: string | QueryParams): Observable<PremiumPay[]> {
        this.log.verbose({
            type: `${this.entityName}DataService(PremiumPayDataService):getWithQuery`,
            params
        });
        return this.http.post<PremiumPay[]>(this.entitiesUrl, params).pipe(
            map(items => items.map(item => this.mapItems(item))),
            catchError((e, c) =>
                fromShared.Errors.handleDataServiceError(this.store, e, c)
            )
        );
    }

    mapItems(item: PremiumPay): PremiumPay {
        return {
            ...item,
            StartDate: new Date(item.StartDate),
            EndDate: new Date(item.EndDate),
            CreatedDate: new Date(item.CreatedDate),
            ModifiedDate: new Date(item.ModifiedDate),
            id: item.Id
        };
    }
}
